import { render, staticRenderFns } from "./outRecord.vue?vue&type=template&id=2e65eb2b&scoped=true&"
import script from "./outRecord.vue?vue&type=script&lang=js&"
export * from "./outRecord.vue?vue&type=script&lang=js&"
import style0 from "./outRecord.vue?vue&type=style&index=0&id=2e65eb2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e65eb2b",
  null
  
)

export default component.exports